'use client'
import classNames from 'classnames'
import {
  SfInputSize,
  type SfInputProps,
  polymorphicForwardRef
} from '@storefront-ui/react'
import React from 'react'

const defaultWrapperTag = `span`

const sizeClasses = {
  [SfInputSize.sm]: ` h-[32px]`,
  [SfInputSize.base]: `h-[40px]`,
  [SfInputSize.lg]: `h-[48px]`
}

const SfInput = polymorphicForwardRef<typeof defaultWrapperTag, SfInputProps>(
  (
    {
      wrapperAs,
      size = SfInputSize.base,
      slotPrefix,
      slotSuffix,
      invalid,
      className,
      wrapperClassName,
      children,
      ...attributes
    },
    ref
  ) => {
    const WrapperTag = wrapperAs || defaultWrapperTag

    return (
      <WrapperTag
        className={classNames( [
          `relative focus-within:outline-none flex items-center gap-2 px-4 w-full ${attributes?.disabled ? `bg-lightGray` : `bg-white`} disabled:bg-lightGray rounded-md ring-1 text-neutral-500 hover:ring-grey-1 focus-within:caret-grey-1 active:caret-grey-1 active:ring-grey-1 active:ring-2 focus-within:ring-grey-1 focus-within:ring-2`,
          {
            'ring-2 ring-negative-700': invalid,
            'ring-1 ring-neutral-300': !invalid
          },
          sizeClasses[size],
          wrapperClassName
        ] )}
        data-testid="input"
      >
        {slotPrefix}
        <input
          className={classNames( [
            `min-w-[30px] w-full text-base outline-none appearance-none text-neutral-900 disabled:cursor-not-allowed disabled:bg-transparent read-only:bg-transparent`,
            className
          ] )}
          type="text"
          data-testid="input-field"
          size={1}
          ref={ref}
          {...attributes}
        />
        {children}
        {slotSuffix}
      </WrapperTag>
    )
  }
)

export default SfInput
